import React, { Component } from 'react'
import HeroOne from './Hero/HeroOne'
import FeaturesOne from './Features/FeaturesOne'
import AboutOne from './About/AboutOne'
import ServiceOne from './Service/ServiceOne'
import TeamOne from './Team/TeamOne'
import Appointment from './Appointment'
import GalleryOne from './Gallery/GalleryOne'
import TestimonailOne from './Testimonial/TestimonailOne'
import BlogOneWordPress from './Blog/BlogOneWordPress'
import Promo from './Promo'
import OurSleepSpecialist from './OurSleepSpecialist'
import SleepDisorder from './SleepDisorder'
import SleepNews from './SleepNews'
import ServiceData from './Data/ServiceData';
import FeaturesData from './Data/FeaturesData';
import TeamData from './Data/TeamData'
import { Helmet } from 'react-helmet'

class HomeOne extends Component {
    render() {
        // Local Business Schema
        const localBusinessSchema = {
            "@context": "https://schema.org",
            "@type": "LocalBusiness",
            "name": "Sleep Therapeutics",
            "url": "https://sleeptherapeutics.in/",
            "logo": "https://sleeptherapeutics.in/static/media/Headerlogo.cdad258d.png",
            "image": "https://sleeptherapeutics.in/static/media/11.6ba85eaf.webp",
            "description": "Sleep Therapeutics is a pioneering sleep clinic in Hyderabad, offering diagnosis and treatment for sleep disorders through a multidisciplinary approach.",
            "telephone": "+91-8886668162",
            "email": "info@sleeptherapeutics.in",
            "openingHoursSpecification": [
                {
                    "@type": "OpeningHoursSpecification",
                    "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
                    "opens": "10:00",
                    "closes": "20:00"
                },
                {
                    "@type": "OpeningHoursSpecification",
                    "dayOfWeek": "Sunday",
                    "opens": "10:00",
                    "closes": "14:00"
                }
            ],
            "department": [
                {
                    "@type": "LocalBusiness",
                    "name": "Sleep Therapeutics - Film Nagar",
                    "address": {
                        "@type": "PostalAddress",
                        "streetAddress": "Plot No.11, Filmnagar, 8-2-293/82, Road No. 82, J-III, Jubilee Hills",
                        "addressLocality": "Hyderabad",
                        "addressRegion": "Telangana",
                        "postalCode": "500033",
                        "addressCountry": "IN"
                    },
                    "telephone": "+91-8886668162",
                    "geo": {
                        "@type": "GeoCoordinates",
                        "latitude": 17.414292,
                        "longitude": 78.411497
                    }
                },
                {
                    "@type": "LocalBusiness",
                    "name": "Sleep Therapeutics - Kukatpally",
                    "address": {
                        "@type": "PostalAddress",
                        "streetAddress": "Metro Pillar No.30, Plot No.35/2, beside Prathima Hospital, JNTU, Bhagya Nagar Colony, Kukatpally",
                        "addressLocality": "Hyderabad",
                        "addressRegion": "Telangana",
                        "postalCode": "500072",
                        "addressCountry": "IN"
                    },
                    "telephone": "+91-8886668164",
                    "geo": {
                        "@type": "GeoCoordinates",
                        "latitude": 17.493476,
                        "longitude": 78.399238
                    }
                }
            ],
            "sameAs": [
                "https://www.facebook.com/sleeptherapeuticsindia",
                "https://www.instagram.com/sleeptherapeuticsindia",
                "https://www.linkedin.com/company/sleeptherapeuticsindia",
                "https://twitter.com/sleeptherap",
                "https://www.youtube.com/@sleeptherapeuticsindia"
            ]
        };

        // Medical Organization Schema
        const medicalOrganizationSchema = {
            "@context": "https://schema.org",
            "@type": "MedicalOrganization",
            "name": "Sleep Therapeutics",
            "url": "https://sleeptherapeutics.in/",
            "logo": "https://sleeptherapeutics.in/static/media/Headerlogo.cdad258d.png",
            "image": "https://sleeptherapeutics.in/static/media/11.6ba85eaf.webp",
            "description": "Sleep Therapeutics specializes in diagnosing and treating sleep disorders using modern sleep labs and a multidisciplinary team of experts including pulmonologists, psychiatrists, and lifestyle coaches.",
            "address": [
                {
                    "@type": "PostalAddress",
                    "streetAddress": "Plot No.11, Filmnagar, 8-2-293/82, Road No. 82, J-III, Jubilee Hills",
                    "addressLocality": "Hyderabad",
                    "addressRegion": "Telangana",
                    "postalCode": "500033",
                    "addressCountry": "IN"
                },
                {
                    "@type": "PostalAddress",
                    "streetAddress": "Metro Pillar No.30, Plot No.35/2, beside Prathima Hospital, JNTU, Bhagya Nagar Colony, Kukatpally",
                    "addressLocality": "Hyderabad",
                    "addressRegion": "Telangana",
                    "postalCode": "500072",
                    "addressCountry": "IN"
                }
            ],
            "contactPoint": [
                {
                    "@type": "ContactPoint",
                    "telephone": "+91-8886668162",
                    "contactType": "Customer Service",
                    "areaServed": "Hyderabad",
                    "availableLanguage": ["English", "Telugu"]
                },
                {
                    "@type": "ContactPoint",
                    "telephone": "+91-8886668164",
                    "contactType": "Customer Service",
                    "areaServed": "Hyderabad",
                    "availableLanguage": ["English", "Telugu"]
                }
            ],
            "medicalSpecialty": [
                "Sleep Medicine",
                "Pulmonology",
                "Psychiatry",
                "Endocrinology",
                "Neurology"
            ],
            "founder": {
                "@type": "Person",
                "name": "Dr. Harshini Errabelli",
                "jobTitle": "Founder & Director",
                "affiliation": "Sleep Therapeutics"
            },
            "foundingDate": "2023",
            "sameAs": [
                "https://www.facebook.com/sleeptherapeuticsindia",
                "https://www.instagram.com/sleeptherapeuticsindia",
                "https://www.linkedin.com/company/sleeptherapeuticsindia",
                "https://twitter.com/sleeptherap",
                "https://www.youtube.com/@sleeptherapeuticsindia"
            ]
        };

        return (
            <React.Fragment>
                <Helmet>
                    <meta charSet='utf-8' />
                    <title>Best Sleep Medicine Center in Hyderabad | Sleep Therapeutics Hyderabad</title>
                    <meta name='description' content='Best sleep medicine and sleep study center in Hyderabad. Get expert treatment for insomnia, sleep apnea, and snoring with advanced sleep studies at Sleep Therapeutics Hyderabad.' />
                    
                    {/* Local Business Schema */}
                    <script type="application/ld+json">
                        {JSON.stringify(localBusinessSchema)}
                    </script>
                    
                    {/* Medical Organization Schema */}
                    <script type="application/ld+json">
                        {JSON.stringify(medicalOrganizationSchema)}
                    </script>
                </Helmet>
                
                <HeroOne />
                <AboutOne />
                <FeaturesOne FeaturesData={FeaturesData} />
                <SleepDisorder />
                {/*<ServiceOne ServiceData={ServiceData} />*/}
                {/*<TeamOne TeamData={TeamData} />*/}
                <OurSleepSpecialist />
                <Appointment appointmentTitle={"Consult our specialists"} />
                <GalleryOne />
                <TestimonailOne />
                <SleepNews />
                <BlogOneWordPress />
                <Promo />
                {/*<ClientLogos />*/}
            </React.Fragment>
        )
    }
}

export default HomeOne